import { render, staticRenderFns } from "./SearchTab.vue?vue&type=template&id=b301a108&scoped=true"
import script from "./SearchTab.vue?vue&type=script&lang=js"
export * from "./SearchTab.vue?vue&type=script&lang=js"
import style0 from "./SearchTab.vue?vue&type=style&index=0&id=b301a108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b301a108",
  null
  
)

export default component.exports